import type { GameMessage, GameMessageType, IncomingMessage } from './types';
import { GAME_MESSAGE_TYPE, WS_MESSAGE_TYPE } from './types';
import { toDisplayString } from '@/lib/displayValue';

export function parseGameMessage(parsed: IncomingMessage): GameMessage {
  if (Array.isArray(parsed) && parsed.length >= 2) {
    const [msgType, args, kwargs = {}] = parsed;
    let content = '';
    let messageType: GameMessageType = GAME_MESSAGE_TYPE.SYSTEM;
    // `logged_in` has no branch below: `dispatchLegacyText` short-circuits it
    // as a silent milestone (#3933), so it never reaches this parser.
    if (msgType === WS_MESSAGE_TYPE.TEXT && Array.isArray(args) && args.length > 0) {
      content = String(args[0]);
      const kw = kwargs as Record<string, unknown>;
      if (kw.from_channel) {
        messageType = GAME_MESSAGE_TYPE.CHANNEL;
      } else if (kw.type === 'narrative') {
        messageType = GAME_MESSAGE_TYPE.NARRATIVE;
      } else if (kw.type === 'gemit') {
        messageType = GAME_MESSAGE_TYPE.GEMIT;
      } else {
        messageType = GAME_MESSAGE_TYPE.TEXT;
      }
    } else if (msgType === WS_MESSAGE_TYPE.VN_MESSAGE) {
      content = toDisplayString((kwargs as Record<string, unknown>).text);
      messageType = GAME_MESSAGE_TYPE.ACTION;
    } else if (msgType === WS_MESSAGE_TYPE.MESSAGE_REACTION) {
      content = JSON.stringify(kwargs);
      messageType = GAME_MESSAGE_TYPE.SYSTEM;
    } else {
      content = JSON.stringify(parsed);
    }

    return { content, timestamp: Date.now(), type: messageType };
  }

  return {
    content: JSON.stringify(parsed),
    timestamp: Date.now(),
    type: GAME_MESSAGE_TYPE.ERROR,
  };
}
